import { render, staticRenderFns } from "./ChildVue.vue?vue&type=template&id=282457a7&"
import script from "./ChildVue.vue?vue&type=script&lang=js&"
export * from "./ChildVue.vue?vue&type=script&lang=js&"
import style0 from "./ChildVue.vue?vue&type=style&index=0&id=282457a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports